module.exports = __webpack_public_path__ + "img/home-section-left-arrow.e283524.png";